import SystemUpload2Fill from './system-upload-2-fill.component.js'

export * from './system-upload-2-fill.component.js'
export default SystemUpload2Fill

SystemUpload2Fill.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-upload-2-fill': SystemUpload2Fill
  }
}
